import {
  HttpClient,
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
  HttpBackend,
  HttpHeaders
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import 'rxjs/add/observable/throw';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import { Observable } from 'rxjs/Observable';
import { environment } from '../../../environments/environment';
import { AppLoadingService } from '../common/loading.service';
import { of } from 'rxjs/observable/of';

@Injectable()
export class DashboardService {
  public hostUrl: any = environment.API_BASE_URL;
  public cellphoneUrl: any = environment.CELLPHONE_BASE_URL;
  public bundleUrl: any = environment.BUNDLE_BASE_URL;
  public insuranceUrl: any = environment.INSURANCE_BASE_URL;
  public pdfParserHostUrl: any = environment.PDF_PARSER_BASE_URL;
  public scraperUrl: any = environment.SCRAPER_BASE_URL;
  public customerUrl: any = environment.CUSTOMER_BASE_URL;

  public token: string;

  public isCableActive = false;
  public isCellphoneActive = false;
  public isInternetActive = false;
  public isElectricityActive = false;
  public isHomePhoneActive = false;
  public isAutoActive = false;
  public isHomeSecurityActive = false;

  public urlToFetchUserAccountDetails: any = this.hostUrl + 'api/getCustomer';
  public urlToFetchMagicUrl: any = this.hostUrl + 'api/getMagicurl';
  public urlToFetchProviders: any = this.hostUrl + 'api/getProviders';
  public urlToSaveAccounts: any = this.hostUrl + 'api/updateAccount';
  public urlToCallPhone: any = this.hostUrl + 'v1/twilio/outbound/call/';
  public urlToGetAccounts: any = this.hostUrl + 'api/getAccountById';
  public urlToCreateAccount: any = this.hostUrl + 'api/createAccount';
  public urlToGetScript: any = this.hostUrl + 'api/getScripts';
  public urlToSaveNotes: any = this.hostUrl + 'api/addNotes';
  public urlToArchiveNotes: any = this.hostUrl + 'api/archiveNotes';
  public urlToGetCalls: any = this.hostUrl + 'api/getCalls';
  public urlToGetChats: any = this.hostUrl + 'api/getChats';
  public urlToSendText: any = this.hostUrl + 'api/sendMessage';
  public urlToSecurityQA: any = this.hostUrl + 'api/addAccountDetails';
  public urlToGetPlans: any = this.hostUrl + 'api/getPlansByProvider';
  public urlToUpVote: any = this.hostUrl + 'api/upvotePlan';
  public urlToDownVote: any = this.hostUrl + 'api/downvotePlan';
  public urlToGetCsrTask: string = this.hostUrl + 'api/getCustomerByClickupId';
  public urlToGetNegoTask: string = this.hostUrl + 'api/getAccountByCardId';
  public urlToGetCustomerByPhone: string = this.hostUrl + 'api/getCustomerByPhone';
  public urlToGetLatestCustomers: string = this.hostUrl + 'api/getLatestCustomers';
  public urlToGetLatestCustomersReport: string = this.hostUrl + 'api/getLatestCustomersReport';
  public urlToGetUnsubscribeReport: string = this.hostUrl + 'api/getCustomerUnsubscribeReport';
  public urlToGetCampaignReport: string = this.hostUrl + 'api/campaignReport';
  public urlToGetCustomerFeedbackReport: string = this.hostUrl + 'api/getCustomerFeedbackReport';
  public urlToGetNegotiatorSLAReport: string = this.hostUrl + 'api/getNegoSLAReport';
  public urlToGetLatestAccounts: string = this.hostUrl + 'api/getLatestAccounts';
  public urlToGetOnboardingStats: string = this.hostUrl + 'api/getOnboardingStats';
  public urlToGetZipInfo: any = this.hostUrl + 'api/getZipcodeInfo';
  public urlToFetchUserActivities: any = this.hostUrl + 'api/getCustomerActivityLogs';
  public urlToSaveContact: any = this.hostUrl + 'api/tokyAddContact';
  public urlToGetRating: any = this.hostUrl + 'api/getRatingByCustomerId';
  public urlToGetRefferal: any = this.hostUrl + 'api/getReferral';
  public urlToGetSavings: any = this.hostUrl + 'api/getSavings';
  public urlToGetAccount: any = this.hostUrl + 'api/getAccount';
  public urlToCreateBundle: any = this.hostUrl + 'api/bundle';
  public urlToUnBundle: any = this.hostUrl + 'api/unbundle';
  public urlToGetCustomerByCardId: any = this.hostUrl + 'api/getCustomerAccountByCardId';
  public urlToGetAccountByCardId: any = this.hostUrl + 'api/getAccountByCardId';
  public urlToGetAgentCardDetails: any = this.hostUrl + 'api/getLastWorkedCards';
  public urlToUpdateEmployee: any = this.hostUrl + 'api/updateEmployee';
  public urlToGetEmployee: any = this.hostUrl + 'api/getEmployee';
  public urlToGetNewLead: any = this.hostUrl + 'api/getNewLeads';
  public urlToGetCustomerRequests: any = this.hostUrl + 'api/getCustomerRequests';
  public urlToUpdateCustomerRequests: any = this.hostUrl + 'api/updateCustomerRequests';
  public urlToDeleteFile: any = this.hostUrl + 'api/deleteFile';

  public urlToStorePdfScrapeDetails: string = this.scraperUrl + 'pdfScraper/createScraper';
  public urlToRemovePdfScraper: string = this.scraperUrl + 'pdfScraper/archiveScraper';
  public urlToGetAllPdfScrapers: string = this.scraperUrl + 'pdfScraper/getAllScrapers';
  public urlToValidatePdf: string = this.scraperUrl + 'pdfScraper/validateScraper';

  public urlToStoreChatScrapeDetails: string = this.scraperUrl + 'chatScraper/createScraper';
  public urlToRemoveChatScraper: string = this.scraperUrl + 'chatScraper/archiveScraper';
  public urlToGetAllChatScrapers: string = this.scraperUrl + 'chatScraper/getAllScrapers';
  public urlToValidateChat: string = this.scraperUrl + 'chatScraper/validateScraper';

  public urlToGetAllTemplates: string = this.pdfParserHostUrl + 'tabulaTemplate/getAllTemplates';
  public urlToCreateTemplate: string = this.pdfParserHostUrl + 'tabulaTemplate/createTemplate';
  public urlToGetTemplate: string = this.pdfParserHostUrl + 'tabulaTemplate/getTemplate';
  public urlToUpdateTemplate: string = this.pdfParserHostUrl + 'tabulaTemplate/updateTemplate';
  public urlToParse: string = this.pdfParserHostUrl + 'tabulaParser/parse';
  public urlToTestComparator: string = this.pdfParserHostUrl + 'tabulaParser/parseTest';
  public urlToGetCellphoneBillDetails: string = this.cellphoneUrl + 'billDetails/cellphoneDetails';
  public urlToGetPhoneCategories: string = this.pdfParserHostUrl + 'plans/getCellphoneCategories';
  public urlToGetBundleCategories: string = this.pdfParserHostUrl + 'plans/getBundleCategories';

  public urlToGetBillStatements: string = this.customerUrl + 'accounts/getBillStatements';
  public urlToGetBillDetails: string = this.customerUrl + 'accounts/getBillDetails';

  public urlToGetConversationDetails: string = this.hostUrl + 'api/getConversationDetails';

  public urlToFetchLatestTexts: string = this.hostUrl + 'api/getConversation/text';

  urlToGetEmployees: any = this.hostUrl + 'api/getEmployee';
  urlToShortenUrl: any = this.hostUrl + 'api/shortenUrl';

  providers: any;

  constructor(private _http: HttpClient, private handler: HttpBackend) {}

  public fetchUserAccountDetails(id: string): Observable<any> {
    return this._http
      .get(this.urlToFetchUserAccountDetails + '/' + id + '/true')
      .map((res: Response) => res);
  }

  public fetchLatestTexts(id: string): Observable<any> {
    return this._http.get(this.urlToFetchLatestTexts + '/' + id).map((res: Response) => res);
  }

  public fetchUserActivities(id: string): Observable<any> {
    return this._http.get(this.urlToFetchUserActivities + '/' + id).map((res: Response) => res);
  }

  fetchProviders(): Observable<any> {
    const API_RESPONSE = JSON.parse(localStorage.getItem('API_RESPONSE_fetchProviders'));
    if (API_RESPONSE) {
      console.log('Cache Hit - fetchProviders');
      return of(API_RESPONSE); // return cached values
    }
    return this._http.get(this.urlToFetchProviders).map((res: Response) => {
      this.providers = res;
      localStorage.setItem('API_RESPONSE_fetchProviders', JSON.stringify(res));
      return res;
    });
  }

  public fetchCategories(billType): Observable<any> {
    if (billType === 'cellphone') {
      return this._http.get(this.urlToGetPhoneCategories).map((res: Response) => res);
    } else {
      return this._http.get(this.urlToGetBundleCategories).map((res: Response) => res);
    }
  }
  public fetchProviderPlans(providerId: string): Observable<any> {
    return this._http.get(this.urlToGetPlans + '/' + providerId).map((res: Response) => res);
  }
  public saveSecurityQA(data): Observable<any> {
    return this._http.post(this.urlToSecurityQA, data).map((res: Response) => res);
  }
  public saveAccountsCreds(data): Observable<any> {
    return this._http.post(this.urlToSaveAccounts, data).map((res: Response) => res);
  }
  public saveNotes(notes: any): Observable<any> {
    return this._http.post(this.urlToSaveNotes, notes).map((res: Response) => res);
  }
  public archiveNotes(note: any): Observable<any> {
    return this._http.post(this.urlToArchiveNotes, note).map((res: Response) => res);
  }
  public createAccount(data): Observable<any> {
    return this._http.post(this.urlToCreateAccount, data).map((res: Response) => res);
  }
  public sendText(text): Observable<any> {
    return this._http.post(this.urlToSendText, text).map((res: Response) => res);
  }
  public fetchAccounts(userId: string): Observable<any> {
    return this._http.get(this.urlToGetAccounts + '/' + userId).map((res: Response) => res);
  }

  public fetchChats(phone: string): Observable<any> {
    return this._http.post(this.urlToGetChats, { phoneNumber: phone }).map((res: Response) => res);
  }

  public fetchCalls(phone: string): Observable<any> {
    return this._http.post(this.urlToGetCalls, { phone }).map((res: Response) => res);
  }

  public fetchScript(userId: string): Observable<any> {
    return this._http.post(this.urlToGetScript, { cust_id: userId }).map((res: Response) => res);
  }
  public callPhone(phone: string): Observable<any> {
    return this._http
      .post(this.urlToCallPhone, {
        phone: '8552264747',
        buttonID: 'UserProfileLogoMenu'
      })
      .map((res: Response) => res);
  }
  public downVotePlan(data): Observable<any> {
    return this._http.post(this.urlToDownVote, data).map((res: Response) => res);
  }
  public upVotePlan(data): Observable<any> {
    return this._http.post(this.urlToUpVote, data).map((res: Response) => res);
  }

  public fetchCsrTask(taskID: string, csrID: string): Observable<any> {
    return this._http
      .post(this.urlToGetCsrTask, { taskId: taskID, _id: csrID })
      .map((res: Response) => res);
  }

  public fetchNegoTask(cardId: string, negoID: string): Observable<any> {
    return this._http
      .post(this.urlToGetNegoTask, { cardId: cardId, _id: negoID })
      .map((res: Response) => res);
  }

  public storePdfScraper(data): Observable<any> {
    return this._http.post(this.urlToStorePdfScrapeDetails, data).map((res: Response) => res);
  }

  public deletePdfScraper(data): Observable<any> {
    return this._http.post(this.urlToRemovePdfScraper, data).map((res: Response) => res);
  }

  public fetchAllPdfScrapers(): Observable<any> {
    return this._http.get(this.urlToGetAllPdfScrapers).map((res: Response) => res);
  }

  public validatePdfScraper(data): Observable<any> {
    return this._http.post(this.urlToValidatePdf, data).map((res: Response) => res);
  }

  public storeChatScraper(data): Observable<any> {
    return this._http.post(this.urlToStoreChatScrapeDetails, data).map((res: Response) => res);
  }

  public deleteChatScraper(data): Observable<any> {
    return this._http.post(this.urlToRemoveChatScraper, data).map((res: Response) => res);
  }

  public fetchAllChatScrapers(): Observable<any> {
    return this._http.get(this.urlToGetAllChatScrapers).map((res: Response) => res);
  }

  public validateChatScraper(providerId: string, employeeId: string): Observable<any> {
    return this._http
      .get(this.urlToValidateChat + '/' + providerId + '?employee_id' + employeeId)
      .map((res: Response) => res);
  }

  public fetchAllTemplates(): Observable<any> {
    return this._http.get(this.urlToGetAllTemplates).map((res: Response) => res);
  }

  public createTemplate(data: any): Observable<any> {
    return this._http.post(this.urlToCreateTemplate, data).map((res: Response) => res);
  }
  public getTemplate(data: any): Observable<any> {
    return this._http.post(this.urlToGetTemplate, data).map((res: Response) => res);
  }
  public updateTemplate(data: any): Observable<any> {
    return this._http.post(this.urlToUpdateTemplate, data).map((res: Response) => res);
  }

  public validateTemplate(data: any): Observable<any> {
    return this._http.post(this.urlToParse, data).map((res: Response) => res);
  }
  public testComparator(data: any): Observable<any> {
    return this._http.post(this.urlToTestComparator, data).map((res: Response) => res);
  }
  public getLatestCustomers(data: any): Observable<any> {
    return this._http.post(this.urlToGetLatestCustomers, data).map((res: Response) => res);
  }
  public getLatestCustomersReport(data: any): Observable<any> {
    return this._http.post(this.urlToGetLatestCustomersReport, data).map((res: Response) => res);
  }
  public fetchUnsubscribeReport(data: any): Observable<any> {
    return this._http.post(this.urlToGetUnsubscribeReport, data).map((res: Response) => res);
  }
  public fetchCampaignReport(data: any): Observable<any> {
    return this._http.post(this.urlToGetCampaignReport, data).map((res: Response) => res);
  }
  public fetchCustomerFeedbackReport(data: any): Observable<any> {
    return this._http.post(this.urlToGetCustomerFeedbackReport, data).map((res: Response) => res);
  }
  public fetchNegotiatorSLAReport(data: any): Observable<any> {
    return this._http.post(this.urlToGetNegotiatorSLAReport, data).map((res: Response) => res);
  }
  public getLatestAccounts(data: any): Observable<any> {
    return this._http.post(this.urlToGetLatestAccounts, data).map((res: Response) => res);
  }

  public getOnboardingStats(): Observable<any> {
    return this._http.get(this.urlToGetOnboardingStats).map((res: Response) => res);
  }

  public fetchCustomerByPhone(phoneNumber: string): Observable<any> {
    return this._http
      .post(this.urlToGetCustomerByPhone, { phoneNumber })
      .map((res: Response) => res);
  }

  public getMagicUrl(query: any): Observable<any> {
    const cacheKeyName = `API_RESPONSE_getMagicUrl_${query.phone || ''}`;
    const API_RESPONSE = JSON.parse(localStorage.getItem(cacheKeyName));
    if (API_RESPONSE) {
      console.log('Cache Hit - getMagicUrl');
      return of(API_RESPONSE); // return cached values
    }
    return this._http.post(this.urlToFetchMagicUrl, query).map((res: Response) => {
      localStorage.setItem(cacheKeyName, JSON.stringify(res));
      return res;
    });
  }
  public saveContact(contact: any): Observable<any> {
    return this._http.post(this.urlToSaveContact, contact).map((res: Response) => res);
  }
  public fetchRefferal(custId: String): Observable<any> {
    return this._http
      .post(this.urlToGetRefferal, { customerId: custId })
      .map((res: Response) => res);
  }
  public fetchRating(custId: String): Observable<any> {
    return this._http.post(this.urlToGetRating, { customerId: custId }).map((res: Response) => res);
  }
  public fetchSavingsByType(type: String): Observable<any> {
    return this._http.post(this.urlToGetSavings, { type: type }).map((res: Response) => res);
  }

  getZipInfo(zipcode: string): Observable<any> {
    return this._http.get(this.urlToGetZipInfo + '?zipcode=' + zipcode).map((res: Response) => res);
  }

  public fetchAccount(account_id: string): Observable<any> {
    return this._http
      .get(this.urlToGetAccount + '?account_id=' + account_id)
      .map((res: Response) => res);
  }
  createBundle(data): Observable<any> {
    return this._http.post(this.urlToCreateBundle, data).map((res: Response) => res);
  }

  unBundle(data): Observable<any> {
    return this._http.post(this.urlToUnBundle, data).map((res: Response) => res);
  }

  getCustomerByCardId(data): Observable<any> {
    return this._http.post(this.urlToGetCustomerByCardId, data).map((res: Response) => res);
  }

  getBillStatements(data): Observable<any> {
    return this._http.post(this.urlToGetBillStatements, data).map((res: Response) => res);
  }
  getBillDetails(data): Observable<any> {
    return this._http.post(this.urlToGetBillDetails, data).map((res: Response) => res);
  }
  getCellphoneBillDetails(data): Observable<any> {
    return this._http.post(this.urlToGetCellphoneBillDetails, data).map((res: Response) => res);
  }

  getAccountByCardId(data): Observable<any> {
    return this._http.post(this.urlToGetAccountByCardId, data).map((res: Response) => res);
  }
  getAgentCardDetails(user_id: string): Observable<any> {
    return this._http
      .post(this.urlToGetAgentCardDetails, { employee_id: user_id })
      .map((res: Response) => res);
  }
  updateEmployeeCurrentStatus(data): Observable<any> {
    return this._http.post(this.urlToUpdateEmployee, data).map((res: Response) => res);
  }
  getNewLead(user_id: string): Observable<any> {
    return this._http
      .post(this.urlToGetNewLead, { employee_id: user_id })
      .map((res: Response) => res);
  }
  getEmployeeCurrentStatus(user_id: string): Observable<any> {
    const API_RESPONSE = JSON.parse(localStorage.getItem('API_RESPONSE_getEmployeeCurrentStatus'));
    if (API_RESPONSE) {
      console.log('Cache Hit - getEmployeeCurrentStatus');
      return of(API_RESPONSE); // return cached values
    }
    return this._http.post(this.urlToGetEmployee, { empId: user_id }).map((res: Response) => {
      localStorage.setItem('API_RESPONSE_getEmployeeCurrentStatus', JSON.stringify(res));
      return res;
    });
  }
  getEmployees(params): Observable<any> {
    const API_RESPONSE = JSON.parse(localStorage.getItem('API_RESPONSE_getEmployees'));
    if (API_RESPONSE) {
      console.log('Cache Hit - getEmployees');
      return of(API_RESPONSE); // return cached values
    }
    return this._http
      .post(this.urlToGetEmployees, params)
      .map((res: Response) => {
        localStorage.setItem('API_RESPONSE_getEmployees', JSON.stringify(res));
        return res;
      })
      .catch(res => Observable.throw(res));
  }
  getCustomerRequests(data): Observable<any> {
    const API_RESPONSE = JSON.parse(localStorage.getItem('API_RESPONSE_getCustomerRequests'));
    if (API_RESPONSE) {
      console.log('Cache Hit - getCustomerRequests');
      return of(API_RESPONSE); // return cached values
    }
    return this._http.post(this.urlToGetCustomerRequests, data).map((res: Response) => {
      localStorage.setItem('API_RESPONSE_getCustomerRequests', JSON.stringify(res));
      return res;
    });
  }
  updateCustomerRequests(data): Observable<any> {
    return this._http.post(this.urlToUpdateCustomerRequests, data).map((res: Response) => res);
  }
  deleteFile(data): Observable<any> {
    return this._http.post(this.urlToDeleteFile, data).map((res: Response) => res);
  }

  getCustomerConversationDetails(type: string, str: string): Observable<any> {
    return this._http
      .get(this.urlToGetConversationDetails + '/' + type + '/' + str)
      .map((res: Response) => res);
  }

  getViewEmailLinkFromVero(data): Observable<any> {
    const httpClient = new HttpClient(this.handler); // to avoid interceptor
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization:
          'token eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJfaWQiOiI1YWVhY2ZiZjEyNDVhODBiZjAzNjYzNmIiLCJ0eXBlIjowLCJpYXQiOjE1MjUzMzgwNDh9.io4vy830_TTtYF36ZnwYqyJXdUSNwF4hDsYEMrsHwmU'
      })
    };
    return httpClient
      .post(`${this.hostUrl}api/getVeroMail`, data, httpOptions)
      .map((res: Response) => res);
  }

  public shortenUrl(urlObj: any): Observable<any> {
    return this._http.post(this.urlToShortenUrl, urlObj).map((res: Response) => res);
  }
}



// WEBPACK FOOTER //
// ./src/app/_services/main/dashboard.service.ts